import React from "react";

export type StatusValue = "all" | "A4" | "A3" | "A2" | "A1";

interface StatusFilterProps {
  value: StatusValue;
  onChange: (value: StatusValue) => void;
}

const StatusFilter = ({ value, onChange }: StatusFilterProps) => {
  // X12 277 Status Categories
  const statusOptions = [
    { value: "all" as StatusValue, label: "All Claims" },
    {
      value: "A4",
      label: "Finalized",
      description: "Claims that have completed processing",
    },
    {
      value: "A3",
      label: "Rejected",
      description: "Claims that cannot be processed as submitted",
    },
    {
      value: "A2",
      label: "Pended",
      description: "Claims requiring additional information",
    },
    {
      value: "A1",
      label: "In Process",
      description: "Claims under initial processing",
    },
  ];

  return (
    <div className="flex items-center gap-2">
      <label className="text-sm font-medium">Status:</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as StatusValue)}
        className="border rounded px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        {statusOptions.map((option) => (
          <option
            key={option.value}
            value={option.value}
            title={option.description}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StatusFilter;
